module.exports = __webpack_public_path__ + "static/media/30.7317c73e.JPG";